<template>
  <BaseButton
    color="error"
    icon="sign-out"
    :loading="isLoading"
    @click="handleLogout"
  />
</template>

<script setup lang="ts">
import { useSessionStore } from '@stores/session';
import { useRouter } from 'vue-router';

const router = useRouter();
const sessionStore = useSessionStore();

const isLoading = computed(() => sessionStore.isLoading || sessionStore.isLoggingOut);

const handleLogout = async (event: MouseEvent) => {
  event.preventDefault();
  const success = await sessionStore.logout();
  if (success) {
    router.push('/login');
  }
};
</script>
